import Session from "supertokens-auth-react/recipe/session";
import { PermissionClaim } from "supertokens-auth-react/recipe/userroles";

export default function HasPermission(permission: string) {
    let claimValue = Session.useClaimValue(PermissionClaim)
    // console.log("[Claimed permission]", claimValue);
    if (claimValue.loading || !claimValue.doesSessionExist) {
        return false;
    }
    let roles = claimValue.value;
    return Array.isArray(roles) && (permission === "any" || roles.includes(permission));
}